import { render, staticRenderFns } from "./QrCodePay.vue?vue&type=template&id=4ac8c4ea&scoped=true"
import script from "./QrCodePay.vue?vue&type=script&lang=js"
export * from "./QrCodePay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac8c4ea",
  null
  
)

export default component.exports